import styled from 'styled-components';
import { palette } from 'styles/colors';
import { StyledButtonPrimary, StyledButtonPrimaryProps } from 'elements/buttons/Button.primary.styles';

interface StyledButtonProProps extends StyledButtonPrimaryProps {
  type: string;
}

export const StyledButtonPro = styled(StyledButtonPrimary)<StyledButtonProProps>`
  background-color: ${palette.proBlue};
  font-size: 16px;
  padding: 11px 20px 13px;
`;
